import { z } from 'zod'

export const batchDeleteIncomesSchema = z.object({
  ids: z.array(z.string().guid()).min(1).max(500),
})

export type BatchDeleteIncomesDto = z.infer<typeof batchDeleteIncomesSchema>
